import { ChangeEvent } from "react";

interface props {
  inputType: string;
  placeholder: string;
  icon: string;
  inputName: string;
  value: string;
  handler: (e: ChangeEvent<HTMLInputElement>) => any;
}
const Input = ({
  inputType,
  placeholder,
  icon,
  inputName,
  value,
  handler,
}: props) => {
  return (
    <div className="flex items-center border border-slate-300 outline-none focus:border-violet-500 rounded-md overflow-hidden w-full">
      <div className="w-[50px] h-full flex justify-center items-center">
        <i className={`${icon} text-violet-500`}></i>
      </div>
      <input
        type={inputType}
        placeholder={placeholder}
        value={value}
        className="p-3 px-5 pl-0 flex-1 outline-none sm:text-sm md:text-base"
        name={inputName}
        onChange={(e: ChangeEvent<HTMLInputElement>) => handler(e)}
      />
    </div>
  );
};

export default Input;
